'use client'

import { useRouter } from 'next/navigation'
import { useState, FormEvent } from 'react'
import { PortalFooterAuth } from '@/components/portal/PortalFooter'
import { PortalLogo } from '@/components/portal/PortalLogo'

export default function PortalLoginPage() {
  const router = useRouter()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [pending, setPending] = useState(false)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setPending(true)
    try {
      const res = await fetch('/api/portal/login', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      })
      const data = (await res.json()) as {
        error?: string
        redirectTo?: string
        selectedShop?: string | null
      }
      if (!res.ok) {
        setError(data.error || 'Sign-in failed.')
        return
      }
      if (data.redirectTo) {
        if (typeof window !== 'undefined') {
          if (data.selectedShop) {
            window.localStorage.setItem('shopify-shop', data.selectedShop)
          } else {
            window.localStorage.removeItem('shopify-shop')
          }
        }
        router.push(data.redirectTo)
        router.refresh()
      }
    } catch {
      setError('Network error.')
    } finally {
      setPending(false)
    }
  }

  return (
    <div className="portal-auth-bg">
      <div className="portal-auth-inner portal-auth-inner--narrow">
        <div className="portal-auth-card portal-auth-card--lux">
          <div className="portal-logo-mark portal-logo-mark--tight">
            <PortalLogo height={44} priority />
            <span className="portal-logo-wordmark">SigmaSense</span>
          </div>
          <h1 className="portal-auth-headline">Sign in</h1>
          {error ? (
            <div className="portal-alert" role="alert">
              {error}
            </div>
          ) : null}
          <form onSubmit={onSubmit} className="portal-form-tight">
            <div className="portal-field">
              <label htmlFor="portal-email">Email</label>
              <input
                id="portal-email"
                className="portal-input portal-input--lux"
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="portal-field">
              <label htmlFor="portal-password">Password</label>
              <input
                id="portal-password"
                className="portal-input portal-input--lux"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="portal-btn-primary portal-btn-primary--lux" disabled={pending}>
              {pending ? '…' : 'Continue'}
            </button>
          </form>
        </div>
        <PortalFooterAuth variant="minimal" />
      </div>
    </div>
  )
}
